module.exports = __webpack_public_path__ + "img/product_active.cdd8e076.png";